
import React from 'react';
import Container from "@mui/material/Container";
import PrimaryContent from '../../Utilities/PrimaryContent';

export default function NCProSoftware() {
  return (
    <Container maxWidth='xl' sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '250px',
      paddingTop: '20px',
      paddingBottom: '20px',
    }}>
      <PrimaryContent variant="body1">
        <span style={{ fontWeight: '700', color: 'rgba(0, 0, 0, 1)' }}>NC Pro Software </span>is a cutting-edge solution designed to revolutionize quality management in engineering and supply chain processes. Powered by GB International Sourcing & Engineering Pte Ltd (UEN: 202413293G), NC Pro empowers businesses to streamline operations, enhance defect management, and drive efficiency through innovation.
      </PrimaryContent>
      <br />
      <PrimaryContent variant="body1">
        With a commitment to delivering world-class technology, NC Pro enables seamless reporting, tracking, and analysis of non-conformances, helping organizations achieve operational excellence. Learn more about us at <a href='https://www.gbinternational.sg' style={{ fontWeight: 700, color: '#2A3DBD', textDecoration: 'none', fontStyle: 'italic', letterSpacing: '0.02em' }}>www.gbinternational.sg</a>.
      </PrimaryContent>
    </Container>
  )
}